const Marquee = () => {
  const phrase = "Premium Fabric Care — Expert Dry Cleaning — Free Pickup & Delivery — South Delhi — ";
  return (
    <section className="py-10 md:py-16 border-y border-foreground/15 overflow-hidden bg-secondary" data-testid="marquee">
      <div className="animate-marquee">
        {[0, 1].map((k) => (
          <span key={k} className="font-serif italic font-light text-5xl md:text-7xl lg:text-8xl text-foreground/90 pr-8">
            {phrase}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
